import { render } from "./Php.vue?vue&type=template&id=2d18eb4a&scoped=true"
import script from "./Php.vue?vue&type=script&lang=js"
export * from "./Php.vue?vue&type=script&lang=js"

import "./Php.vue?vue&type=style&index=0&id=2d18eb4a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d18eb4a"]])

export default __exports__